var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXuanzhuanti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1L2.5 2.5L0.5 13L1 14L4 15L8 15.5L12 15L15 14L15.5 13L13.5 2L12 1L8 0.5L4 1Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13C15.5 13.2199 15.383 13.4892 15.0396 13.7936C14.6969 14.0975 14.1723 14.394 13.4813 14.6532C12.1029 15.1701 10.1651 15.5 8 15.5C5.83494 15.5 3.89713 15.1701 2.51871 14.6532C1.82765 14.394 1.30314 14.0975 0.960383 13.7936C0.61704 13.4892 0.5 13.2199 0.5 13C0.5 12.7801 0.61704 12.5108 0.960383 12.2064C1.30314 11.9025 1.82765 11.606 2.51871 11.3468C3.89713 10.8299 5.83494 10.5 8 10.5C10.1651 10.5 12.1029 10.8299 13.4813 11.3468C14.1723 11.606 14.6969 11.9025 15.0396 12.2064C15.383 12.5108 15.5 12.7801 15.5 13Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0V16",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2L15.5 13",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2L0.5 13",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2H8V13H15.5L13.5 2Z",
    fill: "#00C2FF",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0259 1.8799C13.0261 1.87991 13.025 1.88214 13.0218 1.88654C13.0241 1.88209 13.0257 1.87988 13.0259 1.8799ZM12.9006 2C12.7206 1.86078 12.4031 1.69338 11.9264 1.53447C10.9675 1.21485 9.57928 1 8 1C6.42072 1 5.03245 1.21485 4.07359 1.53447C3.59686 1.69338 3.27937 1.86078 3.09935 2C3.27937 2.13922 3.59686 2.30662 4.07359 2.46553C5.03245 2.78515 6.42072 3 8 3C9.57928 3 10.9675 2.78515 11.9264 2.46553C12.4031 2.30662 12.7206 2.13922 12.9006 2ZM2.97412 1.8799C2.97434 1.87988 2.97592 1.88209 2.9782 1.88654C2.97504 1.88214 2.9739 1.87991 2.97412 1.8799ZM2.97412 2.1201C2.9739 2.12009 2.97504 2.11786 2.9782 2.11346C2.97592 2.11791 2.97433 2.12012 2.97412 2.1201ZM13.0218 2.11346C13.025 2.11786 13.0261 2.12009 13.0259 2.1201C13.0257 2.12012 13.0241 2.11791 13.0218 2.11346ZM8 4C11.3137 4 14 3.10457 14 2C14 0.895431 11.3137 0 8 0C4.68629 0 2 0.895431 2 2C2 3.10457 4.68629 4 8 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXuanzhuanti);
export default __webpack_public_path__ + "static/media/xuanzhuanti.0fb30f4e78261bdadaf4dc954d9269e8.svg";
export { ForwardRef as ReactComponent };